module.exports = __webpack_public_path__ + "img/amsterdam.95f32848.jpg";